export default {
    FETCH_DETAIL_READ_DATA: "FETCH_DETAIL_READ_DATA",
    TOGGLE_SPINNER_DETAIL_READ_DATA: "TOGGLE_SPINNER_DETAIL_READ_DATA",
    CLEAR_DETAIL_READ_DATA: "CLEAR_DETAIL_READ_DATA",
    SET_TREE_EXPANDED_READ: "SET_TREE_EXPANDED_READ",
};